import { render, staticRenderFns } from "./manage-notification.vue?vue&type=template&id=e5181028&scoped=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-notification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-notification.vue?vue&type=style&index=0&id=e5181028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5181028",
  null
  
)

export default component.exports